import { z } from 'zod';

export const contactInfoDto = z.object({
  id: z.union([z.string(), z.number()]).transform(String),
  phone: z.string().default(''),
  email: z.string().default(''),
  working_hours: z.string().default(''),
  address: z.string().default(''),
  city: z.string().nullable().default(null),
  country: z.string().default(''),
  facebook: z.string().default(''),
  instagram: z.string().default(''),
});

export const contactListDto = z.object({ data: z.array(contactInfoDto) });

export type ContactInfoDto = z.infer<typeof contactInfoDto>;
